import axios from 'axios';
import { polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { orgScopedHeaders } from '../../../utils/constants/commonConstants';
import { getTimeStamp } from '../../../utils/dateUtils';
import type { KnownDetailsScope } from '../types';

const ALL_KNOWN_DETAILS_URL = 'unifier/getAllKnownDetails';

export async function fetchAllKnownDetails(orgId: string, scope?: KnownDetailsScope): Promise<unknown> {
    const response = await axios({
        baseURL: polusBaseUrl,
        url: ALL_KNOWN_DETAILS_URL,
        method: POST,
        headers: orgScopedHeaders(orgId),
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                orgId,
                ...(scope && { scope }),
            },
        },
    });

    return response?.data;
}
